<template>
  <SecondaryButton :color-class="buttonClass" @click="$emit('open')">
    <SparklesIcon class="h-4 w-4 mr-1.5" aria-hidden="true" />
    {{ t("label") }}
  </SecondaryButton>
</template>

<script>
import { useI18n } from "vue-i18n";
import { SecondaryButton } from "@estaly/ui";
import { SparklesIcon } from "@heroicons/vue/outline";
import {
  buttonClassFor,
  generalAnalysisTone,
} from "@/components/claim/details/ai-analysis-flow/claimAiAnalysisSummary";

export default {
  name: "AiAnalysisFlowButton",

  components: { SecondaryButton, SparklesIcon },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    declaration: {
      type: Object,
      default: null,
    },
  },

  emits: ["open"],

  computed: {
    buttonClass() {
      return buttonClassFor(generalAnalysisTone(this.declaration));
    },
  },
};
</script>

<i18n src="./AiAnalysisFlowButton.i18n.json"></i18n>
